import React, { createContext, useState } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/global.css';
import 'katex/dist/katex.min.css';

// 定义渲染引擎类型
export type RenderEngine = 'katex' | 'mathjax';

// 创建全局上下文用于共享状态
export const MarkdownContext = createContext<{
  markdown: string;
  renderedMarkdown: string;
  renderEngine: RenderEngine;
  setMarkdown: (text: string) => void;
  setRenderedMarkdown: (text: string) => void;
  setRenderEngine: (engine: RenderEngine) => void;
}>({
  markdown: '',
  renderedMarkdown: '',
  renderEngine: 'katex', // 默认使用KaTeX
  setMarkdown: () => {},
  setRenderedMarkdown: () => {},
  setRenderEngine: () => {}
});

// 提供者组件
const MarkdownProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [markdown, setMarkdown] = useState('');
  const [renderedMarkdown, setRenderedMarkdown] = useState('');
  const [renderEngine, setRenderEngine] = useState<RenderEngine>('katex');

  return (
    <MarkdownContext.Provider 
      value={{ 
        markdown, 
        renderedMarkdown,
        renderEngine,
        setMarkdown, 
        setRenderedMarkdown,
        setRenderEngine
      }}
    >
      {children}
    </MarkdownContext.Provider>
  );
};

// 确保初始加载时应用程序已经准备好
document.addEventListener('DOMContentLoaded', () => {
  console.log('应用已加载，DOM已准备好');
});

ReactDOM.render(
  <React.StrictMode>
    <MarkdownProvider>
      <App />
    </MarkdownProvider>
  </React.StrictMode>,
  document.getElementById('root')
);